var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5078 20 20 15.5469 20 10C20 4.49219 15.5078 0 10 0C4.45312 0 0 4.49219 0 10C0 15.5469 4.45312 20 10 20ZM13.7891 7.5L13.125 8.16406L11.2891 10L13.125 11.8359L13.7891 12.5L12.5 13.8281L11.8359 13.1641L10 11.3281L8.16406 13.1641L7.5 13.8281L6.17188 12.5L6.83594 11.8359L8.67188 10L6.83594 8.16406L6.17188 7.5L7.5 6.21094L8.16406 6.875L10 8.71094L11.8359 6.875L12.5 6.21094L13.7891 7.5Z",
    fill: "#AD1F22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAlert);
export default __webpack_public_path__ + "static/media/x-alert.6d9dfc5be9ce9c7924364df0cd99b21d.svg";
export { ForwardRef as ReactComponent };